import PageBuilder from '@hellodarwin/app-contentful/lib/builder/pageBuilder';
import { usePage } from '@hellodarwin/app-contentful/lib/hooks/usePage';
import PageLayout from '@hellodarwin/app-core/lib/layouts/page-layout';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../features/providers/user-provider';

const ContactClientPage = () => {
  const { t } = useTranslation();
  const { t: hdT } = useTranslations();
  const { profile } = useUser();
  const { data, loading, error } = usePage();
  const contactEmail = profile.contact_email?.trim() ?? '';
  // HubSpot records email-less submissions without an associated contact.
  const isContactFormReady = Boolean(data?.fields?.components && contactEmail);

  // Handle loading and error states
  if (error) return null;
  return (
    <PageLayout
      app="client"
      isLoading={Boolean(loading) || !isContactFormReady}
      tabTitle={hdT('navigation|contactUs')}
      breadcrumbs={[
        {
          breadcrumbName: t('navigation.home'),
          path: '/',
        },
        {
          breadcrumbName: t('navigation|contact'),
        },
      ]}
      noPadding
      noFooter
    >
      {isContactFormReady && (
        <PageBuilder
          components={data?.fields?.components}
          additionalFields={{ email: contactEmail }}
        />
      )}
    </PageLayout>
  );
};

export default ContactClientPage;
